import { useLayoutEffect, useRef } from 'react';

/**
 * A ref that always holds the latest `value`. For callbacks read later from effects, timers or
 * listeners, so they see current props without re-subscribing when an inline callback changes.
 */
export function useLatestRef<T>(value: T) {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  });

  return ref;
}
